/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import React from 'react';
import Loadable from 'react-loadable';

  const AccordionModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "AccordionModule" */ '../components/AccordionModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['AccordionModule'],
  });
  

  const BackToTopModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "BackToTopModule" */ '../components/BackToTopModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['BackToTopModule'],
  });
  

  const BreadcrumbModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "BreadcrumbModule" */ '../components/BreadcrumbModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['BreadcrumbModule'],
  });
  

  const Brochure = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "Brochure" */ '../components/Brochure').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['Brochure'],
  });
  

  const CardModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "CardModule" */ '../components/CardModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['CardModule'],
  });
  

  const CardModuleFull = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "CardModuleFull" */ '../components/CardModuleFull').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['CardModuleFull'],
  });
  

  const CardModuleLinkedItem = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "CardModuleLinkedItem" */ '../components/CardModuleLinkedItem').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['CardModuleLinkedItem'],
  });
  

  const CardModulePrivateArea = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "CardModulePrivateArea" */ '../components/CardModulePrivateArea').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['CardModulePrivateArea'],
  });
  

  const CardsCarouselModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "CardsCarouselModule" */ '../components/CardsCarouselModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['CardsCarouselModule'],
  });
  

  const CardsGridModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "CardsGridModule" */ '../components/CardsGridModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['CardsGridModule'],
  });
  

  const CarouselModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "CarouselModule" */ '../components/CarouselModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['CarouselModule'],
  });
  

  const ChatbotModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "ChatbotModule" */ '../components/ChatbotModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['ChatbotModule'],
  });
  

  const Configurator = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "Configurator" */ '../components/Configurator').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['Configurator'],
  });
  

  const ContactUSSearchModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "ContactUSSearchModule" */ '../components/ContactUSSearchModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['ContactUSSearchModule'],
  });
  

  const ContentBlockModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "ContentBlockModule" */ '../components/ContentBlockModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['ContentBlockModule'],
  });
  

  const ContentDownloadModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "ContentDownloadModule" */ '../components/ContentDownloadModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['ContentDownloadModule'],
  });
  

  const ContentSwitcherModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "ContentSwitcherModule" */ '../components/ContentSwitcherModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['ContentSwitcherModule'],
  });
  

  const ContentSwitcherSecondaryModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "ContentSwitcherSecondaryModule" */ '../components/ContentSwitcherSecondaryModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['ContentSwitcherSecondaryModule'],
  });
  

  const DataTableModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "DataTableModule" */ '../components/DataTableModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['DataTableModule'],
  });
  

  const DealerLocatorModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "DealerLocatorModule" */ '../components/DealerLocatorModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['DealerLocatorModule'],
  });
  

  const DealerPortalSearch = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "DealerPortalSearch" */ '../components/DealerPortalSearch').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['DealerPortalSearch'],
  });
  

  const DownloadButtonModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "DownloadButtonModule" */ '../components/DownloadButtonModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['DownloadButtonModule'],
  });
  

  const FabFloatingModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "FabFloatingModule" */ '../components/FabFloatingModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['FabFloatingModule'],
  });
  

  const FilterableCardsApplicationsModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "FilterableCardsApplicationsModule" */ '../components/FilterableCardsApplicationsModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['FilterableCardsApplicationsModule'],
  });
  

  const FilterableCardsModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "FilterableCardsModule" */ '../components/FilterableCardsModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['FilterableCardsModule'],
  });
  

  const FooterModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "FooterModule" */ '../components/FooterModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['FooterModule'],
  });
  

  const FormContainerModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "FormContainerModule" */ '../components/FormContainerModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['FormContainerModule'],
  });
  

  const FormContainerPrivateAreaModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "FormContainerPrivateAreaModule" */ '../components/FormContainerPrivateAreaModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['FormContainerPrivateAreaModule'],
  });
  

  const FormModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "FormModule" */ '../components/FormModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['FormModule'],
  });
  

  const FullScreenImgVideoModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "FullScreenImgVideoModule" */ '../components/FullScreenImgVideoModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['FullScreenImgVideoModule'],
  });
  

  const GenericVehicleCardsModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "GenericVehicleCardsModule" */ '../components/GenericVehicleCardsModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['GenericVehicleCardsModule'],
  });
  

  const GlobalButtonModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "GlobalButtonModule" */ '../components/GlobalButtonModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['GlobalButtonModule'],
  });
  

  const GlobalMenuModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "GlobalMenuModule" */ '../components/GlobalMenuModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['GlobalMenuModule'],
  });
  

  const HeaderModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "HeaderModule" */ '../components/HeaderModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['HeaderModule'],
  });
  

  const HeroSliderModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "HeroSliderModule" */ '../components/HeroSliderModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['HeroSliderModule'],
  });
  

  const HighlightsModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "HighlightsModule" */ '../components/HighlightsModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['HighlightsModule'],
  });
  

  const HubUsersRouterModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "HubUsersRouterModule" */ '../components/HubUsersRouterModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['HubUsersRouterModule'],
  });
  

  const IFrameModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "IFrameModule" */ '../components/IFrameModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['IFrameModule'],
  });
  

  const LabeledCardsCarouselModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "LabeledCardsCarouselModule" */ '../components/LabeledCardsCarouselModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['LabeledCardsCarouselModule'],
  });
  

  const LanguageBarModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "LanguageBarModule" */ '../components/LanguageBarModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['LanguageBarModule'],
  });
  

  const LayoutTwoColumnsModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "LayoutTwoColumnsModule" */ '../components/LayoutTwoColumnsModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['LayoutTwoColumnsModule'],
  });
  

  const LeadMonitoring = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "LeadMonitoring" */ '../components/LeadMonitoring').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['LeadMonitoring'],
  });
  

  const LightWeightHeader = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "LightWeightHeader" */ '../components/LightWeightHeader').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['LightWeightHeader'],
  });
  

  const LinksListModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "LinksListModule" */ '../components/LinksListModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['LinksListModule'],
  });
  

  const ListingModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "ListingModule" */ '../components/ListingModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['ListingModule'],
  });
  

  const LoginForm = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "LoginForm" */ '../components/LoginForm').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['LoginForm'],
  });
  

  const LoginHeaderModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "LoginHeaderModule" */ '../components/LoginHeaderModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['LoginHeaderModule'],
  });
  

  const MarketLanguageModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "MarketLanguageModule" */ '../components/MarketLanguageModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['MarketLanguageModule'],
  });
  

  const ModelRangeHeroBannerModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "ModelRangeHeroBannerModule" */ '../components/ModelRangeHeroBannerModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['ModelRangeHeroBannerModule'],
  });
  

  const ModularDataTable = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "ModularDataTable" */ '../components/ModularDataTable').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['ModularDataTable'],
  });
  

  const NumbersModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "NumbersModule" */ '../components/NumbersModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['NumbersModule'],
  });
  

  const PageHeaderModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "PageHeaderModule" */ '../components/PageHeaderModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['PageHeaderModule'],
  });
  

  const PageTitleModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "PageTitleModule" */ '../components/PageTitleModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['PageTitleModule'],
  });
  

  const PhotoGalleryModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "PhotoGalleryModule" */ '../components/PhotoGalleryModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['PhotoGalleryModule'],
  });
  

  const PopupButtonModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "PopupButtonModule" */ '../components/PopupButtonModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['PopupButtonModule'],
  });
  

  const PressForm = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "PressForm" */ '../components/PressForm').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['PressForm'],
  });
  

  const PressKitModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "PressKitModule" */ '../components/PressKitModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['PressKitModule'],
  });
  

  const PressKitSingleRow = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "PressKitSingleRow" */ '../components/PressKitSingleRow').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['PressKitSingleRow'],
  });
  

  const PressReleaseCardModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "PressReleaseCardModule" */ '../components/PressReleaseCardModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['PressReleaseCardModule'],
  });
  

  const PressReleaseModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "PressReleaseModule" */ '../components/PressReleaseModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['PressReleaseModule'],
  });
  

  const PromotionCardModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "PromotionCardModule" */ '../components/PromotionCardModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['PromotionCardModule'],
  });
  

  const PromotionsCollectorModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "PromotionsCollectorModule" */ '../components/PromotionsCollectorModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['PromotionsCollectorModule'],
  });
  

  const PromotionsForm = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "PromotionsForm" */ '../components/PromotionsForm').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['PromotionsForm'],
  });
  

  const QuickActionsModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "QuickActionsModule" */ '../components/QuickActionsModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['QuickActionsModule'],
  });
  

  const QuoteModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "QuoteModule" */ '../components/QuoteModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['QuoteModule'],
  });
  

  const RedirectModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "RedirectModule" */ '../components/RedirectModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['RedirectModule'],
  });
  

  const RTE = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "RTE" */ '../components/RTE').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['RTE'],
  });
  

  const ScrollButtonModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "ScrollButtonModule" */ '../components/ScrollButtonModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['ScrollButtonModule'],
  });
  

  const SearchModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "SearchModule" */ '../components/SearchModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['SearchModule'],
  });
  

  const SectionTextCarousel = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "SectionTextCarousel" */ '../components/SectionTextCarousel').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['SectionTextCarousel'],
  });
  

  const SidebarModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "SidebarModule" */ '../components/SidebarModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['SidebarModule'],
  });
  

  const SitecoreJssForm = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "SitecoreJssForm" */ '../components/SitecoreJssForm').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['SitecoreJssForm'],
  });
  

  const SitecoreJssFormNew = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "SitecoreJssFormNew" */ '../components/SitecoreJssFormNew').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['SitecoreJssFormNew'],
  });
  

  const SiteUsersRouterModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "SiteUsersRouterModule" */ '../components/SiteUsersRouterModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['SiteUsersRouterModule'],
  });
  

  const Spacer = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "Spacer" */ '../components/Spacer').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['Spacer'],
  });
  

  const SplitModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "SplitModule" */ '../components/SplitModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['SplitModule'],
  });
  

  const StageCardModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "StageCardModule" */ '../components/StageCardModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['StageCardModule'],
  });
  

  const SubscribeForm = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "SubscribeForm" */ '../components/SubscribeForm').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['SubscribeForm'],
  });
  

  const TabModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "TabModule" */ '../components/TabModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['TabModule'],
  });
  

  const TextBlockModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "TextBlockModule" */ '../components/TextBlockModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['TextBlockModule'],
  });
  

  const TextingModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "TextingModule" */ '../components/TextingModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['TextingModule'],
  });
  

  const TextModalModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "TextModalModule" */ '../components/TextModalModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['TextModalModule'],
  });
  

  const TextModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "TextModule" */ '../components/TextModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['TextModule'],
  });
  

  const TextualPresentationModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "TextualPresentationModule" */ '../components/TextualPresentationModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['TextualPresentationModule'],
  });
  

  const ThreeColumnsGridModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "ThreeColumnsGridModule" */ '../components/ThreeColumnsGridModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['ThreeColumnsGridModule'],
  });
  

  const TransactionalBannerModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "TransactionalBannerModule" */ '../components/TransactionalBannerModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['TransactionalBannerModule'],
  });
  

  const TwoColumn = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "TwoColumn" */ '../components/TwoColumn').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['TwoColumn'],
  });
  

  const VehicleCardsModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "VehicleCardsModule" */ '../components/VehicleCardsModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['VehicleCardsModule'],
  });
  

  const VehiclesandMissionsModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "VehiclesandMissionsModule" */ '../components/VehiclesandMissionsModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['VehiclesandMissionsModule'],
  });
  

  const VersionBannerModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "VersionBannerModule" */ '../components/VersionBannerModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['VersionBannerModule'],
  });
  

  const VideoGalleryModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "VideoGalleryModule" */ '../components/VideoGalleryModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['VideoGalleryModule'],
  });
  

  const WishlistModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "WishlistModule" */ '../components/WishlistModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['WishlistModule'],
  });
  

  const DocHub_DemoModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "../docHub_components/DocHub_DemoModule" */ '../components/../docHub_components/DocHub_DemoModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['../docHub_components/DocHub_DemoModule'],
  });
  

  const DocHub_FooterModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "../docHub_components/DocHub_FooterModule" */ '../components/../docHub_components/DocHub_FooterModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['../docHub_components/DocHub_FooterModule'],
  });
  

  const DocHub_HeaderModule = Loadable({
    loader: () => {
      signalComponentLoad();
      return import(/* webpackChunkName: "../docHub_components/DocHub_HeaderModule" */ '../components/../docHub_components/DocHub_HeaderModule').then(C => {
        signalComponentLoaded();
        return C as any;
      });
    },
    loading: () => <div></div>,
    modules: ['../docHub_components/DocHub_HeaderModule'],
  });
  

function signalComponentLoad() {
	if (typeof window !== 'undefined') {
		if (window.componentsLoading == undefined) {
			window.componentsLoading = 1;
		} else {
			window.componentsLoading++;
		}
	}
}

function signalComponentLoaded() {
	if (typeof window !== 'undefined') {
		if (window.componentsLoading) {
			window.componentsLoading--;

			if (window.componentsLoading === 0) {
				window.dispatchEvent(new Event('componentsLoaded'));
			}
		}
	}
}

const components = new Map();
components.set('AccordionModule', AccordionModule);
components.set('BackToTopModule', BackToTopModule);
components.set('BreadcrumbModule', BreadcrumbModule);
components.set('Brochure', Brochure);
components.set('CardModule', CardModule);
components.set('CardModuleFull', CardModuleFull);
components.set('CardModuleLinkedItem', CardModuleLinkedItem);
components.set('CardModulePrivateArea', CardModulePrivateArea);
components.set('CardsCarouselModule', CardsCarouselModule);
components.set('CardsGridModule', CardsGridModule);
components.set('CarouselModule', CarouselModule);
components.set('ChatbotModule', ChatbotModule);
components.set('Configurator', Configurator);
components.set('ContactUSSearchModule', ContactUSSearchModule);
components.set('ContentBlockModule', ContentBlockModule);
components.set('ContentDownloadModule', ContentDownloadModule);
components.set('ContentSwitcherModule', ContentSwitcherModule);
components.set('ContentSwitcherSecondaryModule', ContentSwitcherSecondaryModule);
components.set('DataTableModule', DataTableModule);
components.set('DealerLocatorModule', DealerLocatorModule);
components.set('DealerPortalSearch', DealerPortalSearch);
components.set('DownloadButtonModule', DownloadButtonModule);
components.set('FabFloatingModule', FabFloatingModule);
components.set('FilterableCardsApplicationsModule', FilterableCardsApplicationsModule);
components.set('FilterableCardsModule', FilterableCardsModule);
components.set('FooterModule', FooterModule);
components.set('FormContainerModule', FormContainerModule);
components.set('FormContainerPrivateAreaModule', FormContainerPrivateAreaModule);
components.set('FormModule', FormModule);
components.set('FullScreenImgVideoModule', FullScreenImgVideoModule);
components.set('GenericVehicleCardsModule', GenericVehicleCardsModule);
components.set('GlobalButtonModule', GlobalButtonModule);
components.set('GlobalMenuModule', GlobalMenuModule);
components.set('HeaderModule', HeaderModule);
components.set('HeroSliderModule', HeroSliderModule);
components.set('HighlightsModule', HighlightsModule);
components.set('HubUsersRouterModule', HubUsersRouterModule);
components.set('IFrameModule', IFrameModule);
components.set('LabeledCardsCarouselModule', LabeledCardsCarouselModule);
components.set('LanguageBarModule', LanguageBarModule);
components.set('LayoutTwoColumnsModule', LayoutTwoColumnsModule);
components.set('LeadMonitoring', LeadMonitoring);
components.set('LightWeightHeader', LightWeightHeader);
components.set('LinksListModule', LinksListModule);
components.set('ListingModule', ListingModule);
components.set('LoginForm', LoginForm);
components.set('LoginHeaderModule', LoginHeaderModule);
components.set('MarketLanguageModule', MarketLanguageModule);
components.set('ModelRangeHeroBannerModule', ModelRangeHeroBannerModule);
components.set('ModularDataTable', ModularDataTable);
components.set('NumbersModule', NumbersModule);
components.set('PageHeaderModule', PageHeaderModule);
components.set('PageTitleModule', PageTitleModule);
components.set('PhotoGalleryModule', PhotoGalleryModule);
components.set('PopupButtonModule', PopupButtonModule);
components.set('PressForm', PressForm);
components.set('PressKitModule', PressKitModule);
components.set('PressKitSingleRow', PressKitSingleRow);
components.set('PressReleaseCardModule', PressReleaseCardModule);
components.set('PressReleaseModule', PressReleaseModule);
components.set('PromotionCardModule', PromotionCardModule);
components.set('PromotionsCollectorModule', PromotionsCollectorModule);
components.set('PromotionsForm', PromotionsForm);
components.set('QuickActionsModule', QuickActionsModule);
components.set('QuoteModule', QuoteModule);
components.set('RedirectModule', RedirectModule);
components.set('RTE', RTE);
components.set('ScrollButtonModule', ScrollButtonModule);
components.set('SearchModule', SearchModule);
components.set('SectionTextCarousel', SectionTextCarousel);
components.set('SidebarModule', SidebarModule);
components.set('SitecoreJssForm', SitecoreJssForm);
components.set('SitecoreJssFormNew', SitecoreJssFormNew);
components.set('SiteUsersRouterModule', SiteUsersRouterModule);
components.set('Spacer', Spacer);
components.set('SplitModule', SplitModule);
components.set('StageCardModule', StageCardModule);
components.set('SubscribeForm', SubscribeForm);
components.set('TabModule', TabModule);
components.set('TextBlockModule', TextBlockModule);
components.set('TextingModule', TextingModule);
components.set('TextModalModule', TextModalModule);
components.set('TextModule', TextModule);
components.set('TextualPresentationModule', TextualPresentationModule);
components.set('ThreeColumnsGridModule', ThreeColumnsGridModule);
components.set('TransactionalBannerModule', TransactionalBannerModule);
components.set('TwoColumn', TwoColumn);
components.set('VehicleCardsModule', VehicleCardsModule);
components.set('VehiclesandMissionsModule', VehiclesandMissionsModule);
components.set('VersionBannerModule', VersionBannerModule);
components.set('VideoGalleryModule', VideoGalleryModule);
components.set('WishlistModule', WishlistModule);
components.set('DocHub_DemoModule', DocHub_DemoModule);
components.set('DocHub_FooterModule', DocHub_FooterModule);
components.set('DocHub_HeaderModule', DocHub_HeaderModule);

export default function componentFactory(componentName) {
  return components.get(componentName);
};

declare global {
  interface Window {
    componentsLoading?: number;
  }
}
